import { clinicApi } from "@/domains/multi/clinicApi";
import { ensureCsrfToken } from "@/domains/shared/services/setupCsrfInterceptor";
import type { SubscriptionPlanId } from "@/domains/subscription/plans";

type CreditCardPayload = {
    holderName: string;
    number: string;
    expiryMonth: string;
    expiryYear: string;
    ccv: string;
};

type HolderPayload = {
    name: string;
    email: string;
    cpfCnpj: string;
    postalCode: string;
    addressNumber: string;
    addressComplement?: string | null;
    phone?: string | null;
    mobilePhone?: string | null;
};

export async function checkoutPixBilling(_useClinicBilling: boolean, planId: SubscriptionPlanId) {
    await ensureCsrfToken();
    const { data } = await clinicApi.checkoutSubscriptionPix({ planSlug: planId });
    return data;
}

export async function pollPixCheckoutBilling(_useClinicBilling: boolean, sessionId: string) {
    const { data } = await clinicApi.pollSubscriptionPixCheckout(sessionId);
    return data;
}

export async function simulatePixCheckoutBilling(_useClinicBilling: boolean, sessionId: string) {
    const { data } = await clinicApi.simulateSubscriptionPixCheckout(sessionId);
    return data;
}

export async function checkoutCreditCardBilling(
    _useClinicBilling: boolean,
    payload: {
        planId: SubscriptionPlanId;
        card: CreditCardPayload;
        holder: HolderPayload;
    },
) {
    const { data } = await clinicApi.checkoutSubscriptionCreditCard({
        planSlug: payload.planId,
        card: payload.card,
        holder: payload.holder,
    });
    return data;
}

export async function changeBillingPaymentMethodBilling(
    _useClinicBilling: boolean,
    payload: {
        paymentMethod: "credit_card" | "pix_automatic";
        planId?: SubscriptionPlanId;
        card?: CreditCardPayload;
        holder?: HolderPayload;
    },
) {
    const { data } = await clinicApi.changeSubscriptionPaymentMethod({
        paymentMethod: payload.paymentMethod,
        planId: payload.planId,
        card: payload.card,
        holder: payload.holder,
    });
    return data;
}
